export default function LicencaService($q, $http, constants) {
  this.getSistemas = function (ids) {
    return _.isEmpty(ids) ? $q.resolve()
      : $http.get(`${constants.services.licencasApi}/services/api/systems`, { params: { id: _.uniq(ids) } })
          .then(response => response.data);
  };

  this.getLicensing = function (p) {
    return _.isEmpty(p) ? $q.resolve()
      : $http.get(`${constants.services.licencasApi}/api/licensing/last`, { params: { entity: p.entity, system: p.system } })
        .then(response => response.data);
  };

  this.getEntidades = function (ids) {
    return _.isEmpty(ids) ? $q.resolve() : $http.get(`${constants.services.licencasApi}/api/entidades/by-id`, { params: { id: ids } })
      .then(response => response.data);
  };
}

LicencaService.$inject = [
  '$q',
  '$http',
  'CONSTANTS'
];
